/* Fix Judge.me Preview Badge in product recommendations */
(function () {
  function fixJudgeMeBadges(root = document) {
    const badges = root.querySelectorAll(
      '.jdgm-widget.jdgm-preview-badge .jdgm-prev-badge'
    );

    badges.forEach((badge) => {
      // sichtbar machen, auch wenn inline display:none gesetzt ist
      badge.style.setProperty('display', 'inline-block', 'important');

      const n = badge.getAttribute('data-number-of-reviews');
      if (!n) return;

      const textEl = badge.querySelector('.jdgm-prev-badge__text');
      if (textEl) textEl.textContent = `(${n})`;
    });
  }

  const boot = () => {
    fixJudgeMeBadges();

    // reagiert auf nachgeladene Sections / App-Blocks
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (
            node.matches('.shopify-app-block, .jdgm-widget') ||
            node.querySelector?.('.jdgm-widget')
          ) {
            fixJudgeMeBadges(node);
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('load', () => fixJudgeMeBadges());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
